// Minimal helpers — variant select, gallery, cart count refresh
document.addEventListener('change', (e) => {
  const t = e.target;
  if (t && t.matches('select[data-variant-select]')) {
    const form = t.closest('form');
    if (!form) return;
    const variantInput = form.querySelector('input[name="id"]');
    if (variantInput) variantInput.value = t.value;
  }
});

document.addEventListener('click', (e) => {
  const t = e.target;
  if (t && t.matches('[data-thumb]')) {
    const url = t.getAttribute('data-thumb');
    const main = document.querySelector('[data-main-image]');
    if (main && url) main.src = url;
  }
});

async function refreshCartCount() {
  try {
    const res = await fetch('/cart.js');
    const data = await res.json();
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = data.item_count;
      el.style.display = data.item_count > 0 ? 'inline-block' : 'none';
    });
  } catch (e) {}
}
refreshCartCount();
